
import { Button, Empty } from 'antd';
import { LikeOutlined, DislikeOutlined } from '@ant-design/icons';
import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

const Messages = () => {
    const { messages } = useSelector(state => state?.chat);
    const user = JSON.parse(localStorage.getItem("admin"));

    // Message component for each chat message
    const MessageComponent = ({ type, message, admin_name, time, messageId, room_id, feedback }) => {
        const [liked, setLiked] = useState(false);
        const [disliked, setDisliked] = useState(false);

        // Set initial state based on feedback prop
        useEffect(() => {
            if (feedback == true) {
                setLiked(true);
                setDisliked(false);
            } else if (feedback == false) {
                setLiked(false);
                setDisliked(true);
            }
        }, [feedback]);

        const handleLike = () => {
            setLiked(true);
            setDisliked(false);
        };

        const handleDislike = () => {
            setLiked(false);
            setDisliked(true);
        };

        return (
            <div className={`flex ${type === "admin" || type === "bot" ? "justify-end" : ""}`}>
                <div
                    className={`flex flex-col rounded-md max-w-[50%] overflow-hidden break-words p-2 
                    ${type === "admin" ? "bg-[#86B6F6]" : type === "bot" ? "bg-blue-950" : "bg-blue-400"}
                `}
                >
                    {type === "admin" && <div className=' text-white text-[10px] font-bold'>{admin_name || user?.name}</div>}
                    {type === "bot" && <div className=' text-white text-[10px] font-bold'>Sally</div>}
                    <div className='text-white text-[10px]'>{message}</div>
                    <div className='text-[8px] text-slate-200 text-right'>{moment(time).format("hh:mm a")}</div>

                    {/* Like/Dislike Buttons */}
                    {(type === "admin" || type === "bot") && (
                        <div className="flex gap-2 mt-2">
                            <Button
                                icon={<LikeOutlined style={{ color: 'white' }} />}
                                onClick={handleLike}
                                type="text"
                                className={liked ? 'bg-blue-600' : ''}
                                size="small"
                                disabled
                            />
                            <Button
                                icon={<DislikeOutlined style={{ color: 'white' }} />}
                                onClick={handleDislike}
                                type="text"
                                className={disliked ? 'bg-red-600' : ''}
                                size="small"
                                disabled
                            />
                        </div>
                    )}
                </div>
            </div>
        );
    };

    return messages?.length ? (
        <div className='text-[12px] flex flex-col gap-2 p-2'>
            {/* {messages?.map(x => (
                <MessageComponent
                    key={x?.timestamp}
                    type={x?.sender}
                    message={x?.message}
                    time={x?.timestamp}
                    admin_name={x?.admin_name}
                    messageId={x?.id}
                    room_id={x?.room_id}
                    feedback={x?.feedback}  // Pass feedback value to the component
                />
            ))} */}
                    {messages?.map((x, index) => (
                <div key={x.id || index} className="message">
                    {x?.message && !x?.message.startsWith('data:audio') ? (
                       <MessageComponent
                       key={x?.timestamp}
                       type={x?.sender}
                       message={x?.message}
                       time={x?.timestamp}
                       admin_name={x?.admin_name}
                       messageId={x?.id}
                       room_id={x?.room_id}
                       feedback={x?.feedback}  // Pass feedback value to the component
                   />
                    ) : (
                        <audio controls>
                        <source src={x?.audio} type="audio/mp3" />
                        Your browser does not support the audio element.
                      </audio>
                      
                    
                    )}
                </div>
            ))}
        </div>
    ) : (
        <div className='flex h-[400px] items-center justify-center'>
            <Empty description={<div className='text-slate-400 text-[11px]'>No Messages Yet</div>} />
        </div>
    );
};

export default Messages;
